module.exports = __webpack_public_path__ + "img/thomas-edison.366deadd.png";